// The door to "Give a task" from any page: add `give=<value>` to the page's
// own URL (merged with what is there) and this host, one per shell
// (CustomerShell, and the companion's phone and embedded shells), opens the
// one start dialog over the page. <value> is `new` (nobody picked), an
// agent or subagent template, `team` or `workflow:<slug>`. The parameter is
// taken out of the URL at once (a replace, the rest of the search and the
// hash kept), so Back never reopens the dialog and Cancel leaves the page
// as it was. Where tasks are off it is only taken out.

import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useCustomerSettings } from "@/api/customerSettings";
import { useAuth } from "@/stores/auth";

import { StartWorkDialog } from "./StartWorkDialog";

const GIVE_PARAM = "give";

export function StartWorkHost() {
  const customerId = useAuth((s) => s.customerId) ?? "";
  const child = useAuth((s) => s.role) === "family";
  const location = useLocation();
  const navigate = useNavigate();
  const give = new URLSearchParams(location.search).get(GIVE_PARAM);
  const settings = useCustomerSettings(give !== null && !child ? customerId || null : null);
  const opens = useRef(0);
  const [open, setOpen] = useState<{ n: number; to?: string } | null>(null);
  const tasksOn = settings.data?.tasks_enabled === true;

  useEffect(() => {
    if (give === null || settings.isLoading) return;
    if (tasksOn) {
      opens.current += 1;
      setOpen({ n: opens.current, to: give === "new" || give === "" ? undefined : give });
    }
    const rest = new URLSearchParams(location.search);
    rest.delete(GIVE_PARAM);
    const search = rest.toString();
    navigate({ pathname: location.pathname, search: search ? `?${search}` : "", hash: location.hash }, { replace: true, state: location.state });
  }, [give, settings.isLoading, tasksOn, location.pathname, location.search, location.hash, location.state, navigate]);

  if (!open || !customerId) return null;
  return <StartWorkDialog key={open.n} customerId={customerId} preset={{ to: open.to, when: "now" }} onClose={() => setOpen(null)} />;
}
